import React from 'react';
import { Icon } from '@awesomecomponents/mux';

export const buildFooterMenus = (lang) => {
  if (lang === 'en-CA') {
    return [
      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'manulife',
        title: 'Manulife',
        label: 'Manulife',
        href: 'https://manulife.ca/',
        ariaLabel: 'Manulife Open a new window',
        isExternal: true,
      },
      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'legal',
        title: 'Legal',
        label: 'Legal',
        href: 'http://www.manulife.com/Legal',
        ariaLabel: 'Legal Open a new window',
        isExternal: true,
      },
      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'privacypolicy',
        title: 'Privacy Policy',
        label: 'Privacy Policy',
        href: 'https://www.manulife.ca/privacy-policies.html',
        ariaLabel: 'Privacy Policy Open a new window',
        isExternal: true,
      },
      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'accessibility',
        title: 'Accessibility',
        label: 'Accessibility',
        href: 'http://www.manulife.com/accessibility',
        ariaLabel: 'Accessibility Open a new window',
        isExternal: true,
      },
    ];
  } else {
    return [
      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'manulife',
        title: 'Manuvie Canada',
        label: 'Manuvie Canada',
        href: 'https://www.manulife.com/fr.html',
        ariaLabel: 'Manuvie Canada ouvre une nouvelle fenêtre',
        isExternal: true,
      },
      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'legal',
        title: 'Notice juridique',
        label: 'Notice juridique',
        href: 'http://www.manuvie.com/Legal?ocmsLang=fr',
        ariaLabel: 'Notice juridique ouvre une nouvelle fenêtre',
        isExternal: true,
      },
      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'privacypolicy',
        title: 'Politique de confidentialité',
        label: 'Politique de confidentialité',
        href: 'https://www.manuvie.ca/politiques-de-confidentialite.html',
        ariaLabel: 'Politique de confidentialité ouvre une nouvelle fenêtre',
        isExternal: true,
      },

      {
        icon: <Icon color="transparent" fill="#FFFFFF" manulifeName="external" />,
        id: 'accessibility',
        title: 'Accessibilité',
        label: 'Accessibilité',
        href: 'http://www.manuvie.com/Accessibility?ocmsLang=fr',
        ariaLabel: 'Accessibilité ouvre une nouvelle fenêtre',
        isExternal: true,
      },
    ];
  }
};

export const buildHeaderRight = (lang) => {
  if (lang === 'en-CA') {
    return [
      {
        id: 'contactusmenu',
        ariaLabel: 'Contact Us Menu',
        label: 'Contact Us Menu',
        Icon: <Icon color="#FFFFFF" manulifeName="contact" />,
        href: 'https://www.manulife.ca/personal/support/contact-us.html',
        isExternal: true,
      },
    ];
  } else {
    return [
      {
        id: 'contactusmenu',
        ariaLabel: 'Contactez-nous Menu',
        label: 'Contactez-nous Menu',
        Icon: <Icon color="#FFFFFF" manulifeName="contact" />,
        href: 'https://www.manuvie.ca/particuliers/soutien/pour-nous-joindre.html',
        isExternal: true,
      },
    ];
  }
};
